import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const activeSectionSlice = createSlice({
  name: "activeSection",
  initialState,
  reducers: {
    activeSectionValue: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { activeSectionValue } = activeSectionSlice.actions;
export default activeSectionSlice.reducer;
